import { render, staticRenderFns } from "./dataProductDesignIntroduce.vue?vue&type=template&id=ac4a3134&scoped=true"
import script from "./dataProductDesignIntroduce.vue?vue&type=script&lang=js"
export * from "./dataProductDesignIntroduce.vue?vue&type=script&lang=js"
import style0 from "./dataProductDesignIntroduce.vue?vue&type=style&index=0&id=ac4a3134&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4a3134",
  null
  
)

export default component.exports